import * as S from '../style';
export default function DeliveryInvoiceInfoComponent({ ...props }: { address: string; name: string; driver: string }) {
  return (
    <S.InvoiceInfoContainer>
      <S.InvoiceInfoWrapper key={'delivery-customer'}>
        <S.InvoiceInfoTitle>고객명</S.InvoiceInfoTitle>
        <S.InvoiceInfo>{props?.name}</S.InvoiceInfo>
      </S.InvoiceInfoWrapper>
      <S.InvoiceInfoWrapper key={'delivery-address'}>
        <S.InvoiceInfoTitle>주소</S.InvoiceInfoTitle>
        <S.InvoiceInfo>{props?.address}</S.InvoiceInfo>
      </S.InvoiceInfoWrapper>
      <S.InvoiceInfoWrapper key={'delivery-driver'}>
        <S.InvoiceInfoTitle>드라이버</S.InvoiceInfoTitle>
        <S.InvoiceInfo>{props?.driver}</S.InvoiceInfo>
      </S.InvoiceInfoWrapper>
    </S.InvoiceInfoContainer>
  );
}
